import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import { getCMSObject, TeleScript } from 'sg-ui-components';
import Layout from '../Components/Layout/Layout';

const HomePage = ({ user, config, cmsSourceFirebase, actions }) => {
    const [components, setComponents] = useState(null);
    const page = {
        title: getCMSObject('data.microsite.general.home.pageInfo.pageTitle'),
        className: 'home',
    };

    useEffect(() => {
        let comps = getCMSObject('data.microsite.general.home.components.cardsContainer.jsonBlock');
        setComponents(comps);
    }, [cmsSourceFirebase]);

    const Card = ({ component }) => (
        <div className='card'>
            <h2 className='card-title' dangerouslySetInnerHTML={{ __html: component?.title }} />
            <div className='card-info' dangerouslySetInnerHTML={{ __html: component?.copyText }} />
            <div className='card-action'>
                <Link to={component?.buttonAction} className='theme-btn'>
                    {component?.buttonLabel}
                </Link>
            </div>
        </div>
    );

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <TeleScript line={getCMSObject('data.microsite.general.home.pageInfo.pageDescription.contentHTML')} />
            </div>
            {components && (
                <>
                    <div className='card-container'>
                        <Card component={components?.promotions} />
                        <Card component={components?.enterTicket} />
                        <Card component={components?.drawings} />
                    </div>
                    <div className='lottery-link d-flex'>
                        <div>
                            <h3 className='text-center text-uppercase' dangerouslySetInnerHTML={{ __html: components?.learnMore?.title }} />
                            <div className='text-center' dangerouslySetInnerHTML={{ __html: components?.learnMore?.copyText }} />
                        </div>
                        <a href={components?.learnMore?.buttonAction} target='_blank' rel='noreferrer' className='theme-btn theme-btn-solid-info py-2'>
                            {components?.learnMore?.buttonLabel}
                        </a>
                    </div>
                </>
            )}
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
